import microsoftStoreIcon from '../../media/MicrosoftStore.svg';

const svgIconStyle = {
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  backgroundPosition: 'center center',
  height: '36px',
  width: '36px',
  margin: '10px 0px -4px',
};

const labelStyle = {
  position: 'absolute',
  right: 5,
  top: 5,
  borderRadius: 12,
  padding: '0 9px',
  fontSize: 12,
};

export const getObjectiveItemStyles = (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  objectiveItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  objectiveItemContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
    position: 'relative',
    '& .icon-MicrosoftStore': {
      backgroundImage: `url("${microsoftStoreIcon}")`,
      ...svgIconStyle,
    },
  },
  objectiveIcon: {
    fontSize: 35,
    lineHeight: '24px',
    color: '#000000',
    marginTop: 13,
  },
  objectiveDescription: {
    fontSize: 14,
    lineHeight: '16px',
    textAlign: 'center',
    color: palette.neutralPrimary,
    marginBottom: '-15px',
    width: '90%',

    '& .empty': {
      color: palette.neutralLighter,
    },
  },
  objectiveHelpIcon: {
    cursor: 'pointer',
    '&:focus': {
      outline: '1px solid #605e5c',
    },
    '&:hover': {
      backgroundColor: palette.neutralLight,
    },
    '&:active': {
      backgroundColor: palette.neutralQuaternaryAlt,
    },
    '&::before': {
      content: '"\\E9CE"',
    },
    fontFamily: iconFontFamily,
    fontSize: 15,
    marginLeft: '0 !important',
    border: 'none',
    backgroundColor: 'inherit',
  },
  newFeatureLabel: {
    ...labelStyle,
    color: palette.white,
    border: `1px solid ${palette.white}`,
    backgroundColor: '#D83B01',
  },
  facLabel: {
    ...labelStyle,
    color: palette.white,
    border: `1px solid ${palette.white}`,
    backgroundColor: palette.themePrimary,
  },
});
